var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoffeechat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 261,
  height: 140
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "m157.278 101.22-2.222 37.466h1.687l5.794-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "m156.237 101.22-2.222 37.466h1.688l4.556-37.466zm-26.494 0-2.222 37.466h1.688l5.793-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9C2DC",
  d: "m128.702 101.22-2.222 37.466h1.688l4.584-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "m166.11 101.22 2.221 37.466h-1.716l-5.765-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2A5CCD",
  d: "M196.878 69.54v31.68h-71.832V90.407c0-5.364 4.36-9.746 9.76-9.746h9.225c5.372 0 9.76-4.353 9.76-9.745 0-5.365 4.359-9.746 9.759-9.746h25.003c4.585.028 8.325 3.763 8.325 8.37"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9C2DC",
  d: "m167.15 101.22 2.222 37.466h-1.716L163.1 101.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "m193.644 101.22 2.222 37.466h-1.716l-5.765-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9C2DC",
  d: "m194.685 101.22 2.222 37.466h-1.716l-4.556-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1744A9",
  d: "M125.046 101.22v-6.235l71.86-16.599v22.834z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "m138.124 131.72-.59 7.275H124.54a3.5 3.5 0 0 1 2.39-3.315l4.67-1.572.674-3.876z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#60D6E6",
  d: "m163.578 30.67 11.39 4.24 2.673 44.796c-9.816.73-20.026 1.433-31.53-.421-1.518-.253-.927 0-2.39-.28 2.42-14.437 1.632-21.57 3.966-35.725.225-1.433 3.15-9.97 4.444-10.645l3.544-1.825z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0CBFD1",
  d: "m154.38 63.22-8.409 2.079-.9 2.246c-.281 3.764-.675 7.555-1.322 11.431 1.463.28.872.028 2.391.28 11.503 1.855 21.713 1.152 31.529.422l-1.857-30.922-8.662-7.133-.76 7.723a15.94 15.94 0 0 1-12.01 13.874"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "M152.468 79.117s-8.212-.225-13.275 0c-5.063.224-5.681 5.223-6.328 9.352-.647 4.128-1.519 44.094-1.519 44.094h7.988l7.875-47.886z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "m176.91 79.762-.282 3.006c-.337 3.735-3.487 6.6-7.228 6.6h-15.582l-8.156 43.729-7.256-1.264s1.884-46.285 5.906-50.133c4.022-3.847 14.738-2.527 14.738-2.527z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A55B3A",
  d: "M163.578 20.53v10.14s-1.688 1.432-4.697 1.263c-2.756-.168-3.206-1.151-3.206-1.151l-1.154-5.252z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8E4A2F",
  d: "M155.478 29.883a12.1 12.1 0 0 0 3.065-1.826 8.63 8.63 0 0 0 2.982-4.213l-6.075 1.152-.929.534z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M147.856 14.661h5.147v1h-5.147z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M149.374 7.555s-.871 2.163-.871 4.044c0 1.517.618 4.382.618 4.382l3.516-8.932z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A55B3A",
  d: "M149.6 24.659c2.756 5.814 9.647 2.387 12.572-.562s2.53-14.127 1.715-16.261c-.815-2.135-7.622-3.848-11.194-2.472s-5.878 13.453-3.094 19.295"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCDDE3",
  d: "M148.503 20.558c.14 1.405.506 2.809 1.068 4.101 1.097 2.303 2.841 3.146 4.754 3.146-1.885 0-3.657-.843-4.754-3.174a13.6 13.6 0 0 1-1.068-4.073"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#90523C",
  d: "M164.422 15.98h-3.094s-2.053 5.393-3.825 5.899c-.14.028-.281.056-.422.056-1.463 0-3.431-1.798-5.906-1.882h-.62c-1.068 0-1.518.168-2.052.505.14 1.405.506 2.809 1.068 4.101 1.097 2.303 2.841 3.146 4.754 3.146 2.868 0 6.075-1.938 7.847-3.708 1.406-1.404 2.053-4.774 2.25-8.116"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M163.493 16.71a3.74 3.74 0 0 1-3.375-4.043v-.113c.17-1.264.535-1.657.197-2.865-.647-2.387-3.515-2.162-5.428-1.263-1.912.898-4.05.87-5.681-.365a3.04 3.04 0 0 1-.703-3.989c1.068-1.74 4.893-3.82 4.893-3.82s-.478 1.04-.309 1.574c.169.533 10.294-2.5 12.375 1.994 2.082 4.493-.703 13.003-.703 13.003l-1.266-.112z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A55B3A",
  d: "M165.265 16.767c0 1.488-1.997 2.837-3.234 2.837-1.238 0-1.21-1.32-1.21-2.837s.985-2.724 2.222-2.724 2.222 1.207 2.222 2.724"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8E4A2F",
  d: "M164.365 16.627c.141.674-.618 1.46-1.18 1.572-.563.113.618-.814.477-1.46-.14-.646-1.125-.983-.562-1.095.562-.113 1.125.308 1.265.983"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M149.74 17.975c-1.125 0-2.053-1.18-2.053-2.64s.928-2.64 2.053-2.64 2.053 1.18 2.053 2.64-.9 2.64-2.053 2.64m0-5c-.984 0-1.772 1.068-1.772 2.36s.816 2.359 1.772 2.359 1.772-1.067 1.772-2.36c0-1.291-.787-2.359-1.772-2.359m4.781 5c-1.125 0-2.053-1.18-2.053-2.64s.928-2.64 2.053-2.64 2.054 1.18 2.054 2.64-.929 2.64-2.054 2.64m0-5c-.984 0-1.771 1.068-1.771 2.36s.787 2.359 1.771 2.359c.985 0 1.772-1.067 1.772-2.36 0-1.291-.787-2.359-1.772-2.359"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M156.378 14.661h4.753v1h-4.753zm-4.726 0h1v1h-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M150.64 21.907h4.725s-.956 2.022-2.56 2.106c-1.602.084-2.165-2.106-2.165-2.106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A2249",
  d: "M148.7 21.99h7.228s-.113-1.516-1.35-2.077c-1.238-.562-2.588.14-3.038.112s-1.603-.787-2.25-.45c-.647.338-.59 2.416-.59 2.416z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26335E",
  d: "m176.825 82.768.281-3.006-17.86-.561a45 45 0 0 0-3.88-.225l9.534 10.392h4.697c3.74 0 6.89-2.865 7.228-6.6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0F1F4",
  d: "M138.209 70.045h5.71l.984-11.29h-7.679z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M138.94 69.483h4.275l.534-6.066a2.93 2.93 0 0 0-1.772-.028c-1.18.224-1.715-.14-2.615-.393-.366-.113-.816.337-.956.168.225 2.809.28 3.51.534 6.32zm5.963 62.237-.591 7.275h-12.994a3.5 3.5 0 0 1 2.39-3.315l4.67-1.572.674-3.876 5.85 1.488z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A55B3A",
  d: "M146.871 69.483s-2.812.506-4.584.253-3.544-1.04-3.91-3.09c-.365-2.05.62-2.387 1.182-2.527s4.781 1.18 4.781 1.18l.169-1.826c.365.225.619.534.787.927.338.702.59 1.292.59 1.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#60D6E6",
  d: "m167.262 42.184 6.188 21.457-27.479 1.63s-.731 2.724 0 4.746h30.038a4.714 4.714 0 0 0 4.725-4.718c0-.169 0-.338-.028-.506-.984-9.352-3.094-28.057-4.247-29.04a7.45 7.45 0 0 0-6.384-1.433c-.76.169-1.406.815-1.913 1.573-1.21 1.882-1.547 4.185-.9 6.291"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M.653 138.854h255.289v1H.653z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "m51.582 101.22 5.794 37.466h1.688l-2.222-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "m53.86 101.22 4.557 37.466h1.687l-2.222-37.466zm25.257 0 5.794 37.466h1.687l-2.222-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9C2DC",
  d: "m81.395 101.22 4.557 37.466h1.687l-2.222-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "m53.27 101.22-5.766 37.466h-1.716l2.222-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2A5CCD",
  d: "M25.594 61.198h25.004c5.372 0 9.76 4.353 9.76 9.746 0 5.364 4.359 9.745 9.759 9.745h9.225c5.372 0 9.76 4.354 9.76 9.746v10.813H17.24V69.539c0-4.606 3.74-8.341 8.353-8.341z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9C2DC",
  d: "m51.02 101.22-4.557 37.466h-1.715l2.222-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19192B",
  d: "m25.735 101.22-5.766 37.466h-1.687l2.193-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9C2DC",
  d: "m23.485 101.22-4.557 37.466h-1.715l2.222-37.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1744A9",
  d: "M17.213 101.22V78.386l71.86 16.599v6.235z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M221.708 19.913h1v91.615h-1zm3.825 8.257h1v91.615h-1zm-1.35 18.873h1v75.774h-1zm-6.919 10.083h1V132.9h-1zm10.603 13.706h1v63.248h-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M215.745 37.606c4.584-2.33 9.788-1.264 11.616 2.331s-.394 8.426-5.006 10.729c-4.613 2.303-14.316 10.981-16.145 7.386s4.95-18.115 9.535-20.446m-5.372 46.173c3.938-4.241 10.688-4.382 15.103-.281 4.416 4.1 4.782 10.813.844 15.054-3.937 4.24-9.928 18.002-14.344 13.93s-5.54-24.462-1.603-28.703m32.935 8.678c-6.75-1.854-13.781 2.303-15.722 9.296-1.94 6.994 1.969 14.183 8.719 16.037s21.685 12.217 23.625 5.224c1.913-6.993-9.872-28.675-16.622-30.557"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M206.857 58.277c5.344-3.623 11.982-3.145 14.823 1.067 2.84 4.213.843 10.532-4.5 14.155-5.344 3.623-16.06 15.953-18.9 11.74-2.842-4.213 3.234-23.339 8.577-26.962"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M206.857 58.277c-5.034 3.398-10.715 20.559-9 26.063 4.64-14.014 7.65-18.143 12.46-23.226a23.7 23.7 0 0 1 6.694-4.943c-3.094-.787-6.891-.113-10.154 2.106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M237.542 41.173c-6.131-1.994-12.375.281-13.978 5.084-1.603 4.802 2.11 10.363 8.213 12.357 6.13 1.994 19.828 10.925 21.431 6.123s-9.534-21.542-15.666-23.564"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M237.542 41.173c5.766 1.882 15.976 16.823 15.835 22.609-8.297-12.19-12.347-15.335-18.366-18.93a23.4 23.4 0 0 0-7.79-2.92c2.727-1.601 6.552-1.995 10.321-.759"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M230.117 22.609c-3.937 1.657-6.103 5.533-4.781 8.622 1.322 3.117 5.569 4.269 9.534 2.612 3.938-1.657 14.71-3.146 13.416-6.235-1.322-3.118-14.203-6.656-18.169-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M221.708 13.284c2.475 1.686 3.375 4.634 2.053 6.572s-4.416 2.135-6.891.45-9.619-4.241-8.297-6.18c1.35-1.937 10.66-2.555 13.135-.842"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M230.117 22.609c3.713-1.573 15.357 1.488 17.804 4.465-9.479-2.5-12.882-2.33-17.466-1.516-1.828.337-3.6.983-5.204 1.938.704-2.023 2.447-3.876 4.866-4.887"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M242.464 73.275c-7.116-4.887-16.538-4.859-21.066.028s-2.419 12.779 4.697 17.666c7.116 4.886 20.785 20.867 25.313 15.98 4.5-4.887-1.828-28.815-8.944-33.674"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M242.464 73.275c6.694 4.578 12.713 26.035 9.62 32.607-4.895-17.497-8.663-22.805-14.823-29.434a32.2 32.2 0 0 0-8.888-6.628c4.444-.702 9.704.45 14.091 3.455"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9398",
  d: "M239.286 112.847h-23.485c-1.575 0-2.84 5.814-2.84 13.004v13.003h29.166V125.88c0-7.218-1.266-13.032-2.84-13.032z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4828B",
  d: "M221.848 112.847h-6.047c-1.575 0-2.84 5.814-2.84 13.004v13.003h6.047V125.88c0-7.218 1.265-13.032 2.84-13.032z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB0B2",
  d: "M240.299 115.43h-25.51a2.225 2.225 0 0 1-2.222-2.218v-3.061h29.982v3.061c0 1.236-1.013 2.219-2.25 2.219z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "M198.448 103.242c3.01-5.701 9.084-8.398 13.584-6.01 4.5 2.359 5.682 8.903 2.672 14.604-3.009 5.701-6.665 21.626-11.165 19.238-4.472-2.359-8.1-22.13-5.091-27.832"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M198.448 103.242c-2.84 5.364.197 23.17 4.303 27.243-2.503-14.549-1.772-19.604.056-26.344a22.8 22.8 0 0 1 3.6-7.5c-3.065.731-6.103 3.09-7.96 6.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0CBFD1",
  d: "m83.527 39.18 7.622 21.204 12.516-20.166s2.953 1.011 3.656 2.753c0 0-8.578 20.783-13.078 25.67s-9.816-1.63-9.816-1.63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E56107",
  d: "m73.936 34.152 10.857 8.678-1.519-25.192z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C99C",
  d: "m75.877 34.742-7.397-.281s-5.485 1.18-8.86 4.24c-3.375 3.062-1.265 47.128-1.265 47.128s13.022 4.746 20.953 3.483c5.822-.927 7.735-2.163 7.735-2.163s-1.378-43.954-3.769-48.447c-2.419-4.494-7.397-3.96-7.397-3.96"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B98F",
  d: "M79.308 89.283c5.822-.926 7.735-2.162 7.735-2.162s-.169-5.926-.535-13.65L60.24 68.276l3.628-16.936-6.131 4.466c-.169 13.509.619 29.995.619 29.995s13.022 4.774 20.953 3.482z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M68.508 23.002v11.375s1.603 1.628 4.416 1.432c2.081-.14 2.981-1.124 2.981-1.124l1.097-6.066z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E68D5C",
  d: "M68.508 24.94c.084.196.169.393.281.59 1.463 2.5 4.388 6.178 7.482 7.218l.76-4.129-8.523-5.589z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M83.724 27.608c-3.01 6.516-10.603 1.264-13.81-2.022-3.206-3.314-2.643-14.464-1.772-16.851.872-2.388 8.297-4.326 12.179-2.78 3.937 1.516 6.412 15.109 3.403 21.653"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F76A00",
  d: "m74.161 44.852-14.569-6.178s2.757-23.367 4.67-28.142c2.165-5.42 6.327-7.33 15.665-5.701 6.075 2.359 5.456 9.436 5.54 10.167-1.406-.253-2.84-.281-4.246-.028-1.575.28-3.15.337-4.725.14l-2.982-.365z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M68.846 21.401c0 1.236 1.575 2.331 2.559 2.331s.956-1.095.956-2.33c0-1.237-.787-2.22-1.744-2.22-.956 0-1.771.983-1.771 2.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0F1F4",
  d: "M78.83 84.031h5.71l.984-11.29h-7.678z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M79.561 83.47h4.275l.535-6.067a2.93 2.93 0 0 0-1.772-.028c-1.181.225-1.716-.14-2.616-.393-.365-.112-.815.337-.956.169.225 2.808.281 3.51.534 6.319"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M73.374 24.575c0 .983-.76 1.77-1.716 1.77s-1.716-.787-1.716-1.77.76-1.77 1.716-1.77 1.716.787 1.716 1.77"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#222747",
  d: "M75.033 83.779s20.25-2.668 24.357.28c4.106 2.95 4.275 8.707 1.772 13.37-1.632 3.089-26.86 30.753-26.86 30.753s-2.447-1.405-2.84-3.567l19.603-28.9-13.135-.112z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M74.443 83.414c1.546.505 3.206.674 4.809.505 2.784-.28 3.263-1.629 3.431-2.668.17-1.04-3.993-.87-3.993-.87l.421-.9s-.618-.393-1.828-.28-1.237 1.123-2.194 1.32c-.956.196-.646 2.893-.646 2.893"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#60D6E6",
  d: "M59.114 39.544s-9.112 23.367-9.816 30.108c-.703 6.74 25.313 13.874 25.313 13.874s.62-2.163 1.04-3.764L56.696 68.641s8.297-13.65 7.313-21.177-4.894-7.92-4.894-7.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#222747",
  d: "m72.305 124.615-5.231 6.038 6.187 8.313h6.47v-.308c0-1.012-.563-1.882-1.435-2.275l-3.178-1.348-1.238-6.235.534-1.63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "m77.93 130.007-1.631 8.988H91.12c0-1.377-.844-2.584-2.081-2.921l-7.425-2.079.365-4.55-4.05.562z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#303D72",
  d: "M58.383 85.745s19.181-3.202 27.507-1.685c8.325 1.516 5.793 10.363 5.147 14.155-.647 3.763-8.157 34.123-8.157 34.123s-2.25.365-4.134-.505l-1.885-.87 5.26-35.36-11.532.084c-5.822-.028-10.884-4.129-12.206-9.942"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#27345E",
  d: "M79.983 83.638c-9.197.028-21.628 2.079-21.628 2.079 1.35 5.841 6.412 9.942 12.234 9.914l2.307-.028z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBAD83",
  d: "M103.665 41.089s1.687-3.82 3.234-5.28 5.625-1.46 9.226 3.37c0 0-.141.478-1.632 1.264s-3.937-.421-4.753-.506c-.816-.084-3.769 2.893-3.769 2.893z"
}))));
export default SvgCoffeechat;